import "../../App.css";
import EconoJournalLogo from "../../components/EconoJournalLogo";
import { useLanguage } from "../../context/LanguageContext";

function App() {
  const { language } = useLanguage();

  const t = {
    EN: {
      soldOut: "SOLD OUT",
      title: "We are working on registration for the next eDay",
      subtitle: "You will be able to register here soon",
    },
    ES: {
      soldOut: "SOLD OUT",
      title: "Estamos trabajando en las inscripciones del próximo eDay",
      subtitle: "Pronto vas a poder registrarte aquí",
    },
  };

  return (
    <div className="bgMaintenance">
      <div className="contentMaintenance">
        <div>
          <EconoJournalLogo className="logoECJMaintenance" forceLightLogo />
        </div>
        <h1>{t[language].soldOut}</h1>
        <h2>{t[language].title}</h2>
        <h3>{t[language].subtitle}</h3>
      </div>
    </div>
  );
}

export default App;
